import { flowRight as compose } from "lodash-es";
import type { RouteRecord, RouteRecordRaw } from "vue-router";
import type { AppSpec } from "../types";
import { navigateTo } from "./navigator";

let appRoutes: any[] = [];
let indexRoute: any = null;

function getBase(app: any) {
  return app.category === app.id ? `/${app.id}` : `/${app.category}/${app.id}`;
}

function setIndexRoute(spec: any) {
  const indexPath = getBase(spec);
  if (__DEV__) {
    console.debug("index route:", spec, "index path:", indexPath);
  }
  indexRoute = {
    path: "",
    redirect: indexPath,
  };
}

let routes: RouteRecordRaw[] = [];
export function getRoutes() {
  if (routes.length === 0) {
    routes = indexRoute ? [indexRoute].concat(appRoutes) : appRoutes;
  }
  return routes;
}

function travelRoutes(operator: (r: RouteRecord) => RouteRecord, routes: any[]) {
  return routes.map(route => {
    const newRoute = operator(route);
    const children = newRoute.children;
    // __DEV__ && console.debug("travelRoutes", route);
    if (children) {
      newRoute.children = travelRoutes(operator, children);
    }
    return newRoute;
  });
}

function addBaseToPath(base: string, path: string) {
  if (path) {
    return path[0] === "/" ? base + path : path;
  }
  return path;
}

// TODO: test
function addBaseToRoute(base: string) {
  return (route: RouteRecord) => {
    ["path", "redirect", "alias"].forEach(prop => {
      if ((route as any)[prop]) {
        (route as any)[prop] = addBaseToPath(base, (route as any)[prop]);
      }
    });
    return route;
  };
}

function addMenuInfo(app: any) {
  return (route: any) => {
    const oldMeta = route.meta || {};
    const meta = {
      ...oldMeta,
      primaryMenu: app.category,
      secondaryMenu: app.category === app.id ? undefined : app.id,
    };
    return {
      ...route,
      meta,
    };
  };
}

export function addRoute(app: AppSpec) {
  const base = getBase(app);
  const operator = compose(addBaseToRoute(base), addMenuInfo(app));
  __DEV__ && console.debug("addRoute for", app);
  const newRoutes = travelRoutes(operator, app.routes);
  __DEV__ && console.debug("addRoute end", newRoutes);
  appRoutes = appRoutes.concat(newRoutes);

  if (app.index) {
    setIndexRoute(app);
  }

  function linkTo(path: string) {
    const cleanPath = path[0] === "/" ? path : `/${path}`;
    return `${base}${cleanPath}`;
  }

  function createGoto(replace: boolean) {
    return (arg: any) => {
      navigateTo(arg, replace);
    };
  }

  return {
    linkTo,
    push: createGoto(false),
    replace: createGoto(true),
  };
}
